module.exports = "https://www.gc-qa.gnp.com.mx/4d00ba268155b2fdf2c3f2641f69023d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/04-facturas-over.svg
// module id = 8038
// module chunks = 0